import { writable } from 'svelte/store';

// Use a single writable store as a form of event bus
export const events = writable("");
export const doneTasks = writable([]);
export function addDoneTask(taskType) {
  doneTasks.update(tasks => [
    ...tasks,
    {type: taskType, time: Date.now()}
  ]);
}